import camelcaseKeys from 'camelcase-keys';
import { Key, useEffect, useState } from 'react';
import { getUnitScriptsSerivice } from '../services';

const useGetUnitScripts = (
  unitId: number | undefined,
  rerender: Key | undefined
): {
  scriptsChats: any[];
  isFetchingScripts: boolean;
} => {
  const [scriptsChats, setData] = useState<any>([]);
  const [isFetchingScripts, setIsFetching] = useState<boolean>(false);
  useEffect(() => {
    if (unitId) {
      setIsFetching(true);
      getUnitScriptsSerivice(
        {
          unitId
        },
        {
          errorAction: () => {
            setData([]);
            setIsFetching(false);
          },
          successAction: (response) => {
            if (response && response?.data && response?.data?.length > 0) {
              setData(
                response.data.map((script) => {
                  return camelcaseKeys({
                    ...script
                  });
                })
              );
            } else setData([]);
            setIsFetching(false);
          }
        }
      );
    }
  }, [rerender]);
  return { scriptsChats, isFetchingScripts };
};

export default useGetUnitScripts;
